import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine/ext-loader';

import { PipeDiagramApplier } from './applier';

/**
 * Registers the client-side {@link PipeDiagramApplier} into the edgeless editor scope, so agent
 * diagrams (dropped as specs into `pipe:pending-diagrams`) are minted into the live surface and
 * render with no reload. Edgeless-only — page docs have no surface to mint into.
 */
export class PipeDiagramApplierViewExtension extends ViewExtensionProvider {
  override name = 'pipe-view-diagram-applier';

  override setup(context: ViewExtensionContext) {
    super.setup(context);
    if (this.isEdgeless(context.scope)) {
      context.register(PipeDiagramApplier);
    }
  }
}
